import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHint = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 25,
	viewBox: "0 0 26 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.66667 8H18.3333M7.66667 13.3333H15.6667M21 1.33333C22.0609 1.33333 23.0783 1.75476 23.8284 2.5049C24.5786 3.25505 25 4.27246 25 5.33333V16C25 17.0609 24.5786 18.0783 23.8284 18.8284C23.0783 19.5786 22.0609 20 21 20H14.3333L7.66667 24V20H5C3.93913 20 2.92172 19.5786 2.17157 18.8284C1.42143 18.0783 1 17.0609 1 16V5.33333C1 4.27246 1.42143 3.25505 2.17157 2.5049C2.92172 1.75476 3.93913 1.33333 5 1.33333H21Z",
		stroke: "#0A0A0A",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHint;
